













































































































































import { defineComponent, getCurrentInstance, onMounted, ref } from "vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import { readBoaHora, saveBoaHora } from "@/utils/programaBoaHora";

const coverImageMobile = process.env.VUE_APP_BASE_URL + "images/health_programs/boa-hora.png";
const coverImageDesktop = process.env.VUE_APP_BASE_URL + "images/health_programs/boa-hora-desktop.jpg";

export default defineComponent({
  components: { FixedButtonRow },
  setup() {
    const context = getCurrentInstance().proxy;
    const accepted = ref(false);
    const showTerms = ref(false);

    onMounted(() => {
      context.$root.$emit("hide-loading");
      const record = readBoaHora(context.$store.state.saude.vinculo);
      if (record.joined) {
        context.$router.replace({ name: "programa_saude_2.boa_hora.acompanhamento" });
      }
    });

    const join = () => {
      if (!accepted.value) return;
      saveBoaHora(context.$store.state.saude.vinculo, { joined: true });
      context.$router.push({ name: "programa_saude_2.boa_hora.acompanhamento" });
    };

    return { coverImageMobile, coverImageDesktop, accepted, showTerms, join };
  }
});
